import React, { useRef } from "react";
import { connect } from "react-redux";
import {
  addToCart,
  addToWishlist,
  addToCompare,
  removeFromWishlist,
} from "../../../actions";
import { Link } from "react-router-dom";
import classes from "./homeGlitz.module.scss";
import DynamicDots from "../DynamicDots";
import useSliderIndex from "../useSliderIndex";

const HomeGlitz = (props) => {
  const sliderRef = useRef(null);
  const activeIndex = useSliderIndex(sliderRef);

  const {
    addToCart,
    addToWishlist,
    addToCompare,
    removeFromWishlist,
    wishListItems,
    symbol,
    searchResults,
    image,
    inverse,
    topHeading,
    heading,
  } = props;

  if (!searchResults || searchResults.length === 0) return null;

  const inr = new Intl.NumberFormat("en-IN", { style: "decimal" });

  const validateURL = (url) => {
    try {
      const parsed = new URL(global.publicUrl + url);
      return ["https:", "http:"].includes(parsed.protocol);
    } catch (e) {
      return false;
    }
  };

  const formatUrlValue = (value) => {
    return value ? value.replace(/_/g, "-") : "";
  };

  const img_fallback = (event) => {
    event.target.src = window.no_image;
  };

  return (
    <section className={classes.home_glitz_section}>
      <div
        className={`${classes.glitz_wrapper} ${inverse ? classes.inverse : ""
          }`}
      >
        {/* Left - Banner Image */}
        <div className={classes.glitz_image}>
          <figure>
            <img
              src={`${process.env.PUBLIC_URL}${image ? image : (window.lookbook && window.lookbook.zoomImage) || ""
                }`}
              alt={heading || "Putting on the glitz"}
              loading="lazy"
            />
          </figure>
        </div>

        {/* Right - Product Slider */}
        <div className={classes.glitz_content}>
          <div
            ref={sliderRef}
            data-uk-slider="autoplay:true;autoplay-interval:4000;velocity:1;easing:smooth;clsActivated: uk-transition-active"
          >
            <div className="uk-position-relative">
              <div className="uk-slider-container">
                <ul className="uk-slider-items">
                  {searchResults.map((item, index) => {
                    const variant = item.variants && item.variants[0];
                    const pictures = (variant && variant.image && variant.image.split(",")) || [];

                    return (
                      <li key={index} className={classes.slide_item}>
                        <div className={classes.product_card}>
                          <div className={classes.product_images}>
                            {pictures[0] && (
                              <div className={classes.product_img_wrap}>
                                <Link
                                  to={
                                    validateURL(
                                      `${process.env.PUBLIC_URL}/${item.value}`
                                    )
                                      ? `${process.env.PUBLIC_URL}/${formatUrlValue(
                                        item.value
                                      )}`
                                      : "#"
                                  }
                                >
                                  <figure>
                                    <img
                                      src={`${pictures[0].trim()}`}
                                      alt={item.name}
                                      onError={img_fallback}
                                      loading="lazy"
                                    />
                                  </figure>
                                </Link>
                              </div>
                            )}
                          </div>
                          <div className={classes.product_info}>
                            <h3 className={classes.product_name}>
                              {item.name && item.name.toUpperCase()}
                            </h3>
                            <p className={classes.product_price}>
                              {symbol} {inr.format(variant && variant.offerprice)}
                            </p>
                            <Link
                              to={`${process.env.PUBLIC_URL}/${formatUrlValue(
                                item.value
                              )}`}
                              className={classes.shop_now_btn}
                            >
                              SHOP NOW
                            </Link>
                          </div>
                        </div>
                      </li>
                    );
                  })}
                </ul>
              </div>

              {/* Navigation Arrows */}
              <div className={classes.arrow_container}>
                <a
                  className={classes.arrow}
                  href="#"
                  data-uk-slider-item="previous"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
                    <path d="M6.89314 1.69812C6.9768 1.42768 7.26387 1.27626 7.53431 1.35992C7.80476 1.44358 7.95618 1.73065 7.87252 2.00109L7.38283 1.84961L6.89314 1.69812ZM1.74438 8.00064V8.51323H-6.67572e-05L1.46709 7.56953L1.74438 8.00064ZM1.74438 8.00064V7.48805H16.6094V8.00064V8.51323H1.74438V8.00064ZM3.6336 6.78547L3.91089 7.21658L2.02168 8.43175L1.74438 8.00064L1.46709 7.56953L3.35631 6.35437L3.6336 6.78547ZM7.38283 1.84961L7.87252 2.00109C7.20721 4.15179 5.80429 5.99873 3.91089 7.21658L3.6336 6.78547L3.35631 6.35437C5.04668 5.2671 6.29916 3.61821 6.89314 1.69812L7.38283 1.84961Z" fill="#626262" />
                    <path fillRule="evenodd" clipRule="evenodd" d="M4.21891 11C5.38568 11.8771 6.3135 13.0337 6.91618 14.3633C7.03304 14.6211 7.33708 14.7349 7.59489 14.6182C7.85236 14.5012 7.96637 14.1981 7.84977 13.9404C7.34991 12.8377 6.64985 11.8414 5.78922 11H4.21891Z" fill="#626262" />
                  </svg>
                </a>
                <a
                  className={classes.arrow}
                  href="#"
                  data-uk-slider-item="next"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
                    <path d="M9.71624 1.69812C9.63257 1.42768 9.34551 1.27626 9.07506 1.35992C8.80461 1.44358 8.65319 1.73065 8.73686 2.00109L9.22655 1.84961L9.71624 1.69812ZM14.865 8.00064V8.51323H16.6094L15.1423 7.56953L14.865 8.00064ZM14.865 8.00064V7.48805H0V8.00064V8.51323H14.865V8.00064ZM12.9758 6.78547L12.6985 7.21658L14.5877 8.43175L14.865 8.00064L15.1423 7.56953L13.2531 6.35437L12.9758 6.78547ZM9.22655 1.84961L8.73686 2.00109C9.40217 4.15179 10.8051 5.99873 12.6985 7.21658L12.9758 6.78547L13.2531 6.35437C11.5627 5.2671 10.3102 3.61821 9.71624 1.69812L9.22655 1.84961Z" fill="#626262" />
                    <path fillRule="evenodd" clipRule="evenodd" d="M12.3905 11C11.2237 11.8771 10.2959 13.0337 9.6932 14.3633C9.57634 14.6211 9.27229 14.7349 9.01449 14.6182C8.75701 14.5012 8.643 14.1981 8.7596 13.9404C9.25946 12.8377 9.95952 11.8414 10.8202 11H12.3905Z" fill="#626262" />
                  </svg>
                </a>
              </div>
            </div>

            <DynamicDots total={searchResults.length} activeIndex={activeIndex} classes={classes} sliderRef={sliderRef} />
          </div>
        </div>
      </div>
    </section>
  );
};

const mapStateToProps = (state) => ({
  wishListItems: state.wishlist.list,
  symbol: state.data.symbol,
});

export default connect(mapStateToProps, {
  addToCart,
  addToWishlist,
  removeFromWishlist,
  addToCompare,
})(HomeGlitz);
